<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.5 7.4925C1.5 4.185 4.185 1.5 7.4925 1.5C10.8 1.5 13.4775 4.185 13.485 7.4925C13.485 10.8 10.8 13.485 7.4925 13.485C4.185 13.485 1.5 10.8 1.5 7.4925ZM8.595 7.2825L6.7875 6.6525C6.6075 6.5925 6.5625 6.5775 6.57 6.3225C6.57 6.1275 6.705 5.97 6.8775 5.97H8.0025C8.2425 5.97 8.4375 6.1875 8.4375 6.4575C8.4375 6.765 8.6925 7.02 9 7.02C9.3075 7.02 9.5625 6.765 9.5625 6.4575C9.5625 5.5875 8.895 4.89 8.0625 4.8525V4.8075C8.0625 4.5 7.8075 4.245 7.5 4.245C7.1925 4.245 6.9375 4.5 6.9375 4.8075V4.8375H6.87C6.0825 4.8375 5.4375 5.505 5.4375 6.315C5.4375 7.0275 5.76 7.485 6.405 7.71L8.2125 8.34L8.21378 8.34045C8.38522 8.40008 8.43 8.41565 8.43 8.6775C8.43 8.8725 8.295 9.03 8.1225 9.03H6.9975C6.7575 9.03 6.5625 8.8125 6.5625 8.5425C6.5625 8.235 6.3075 7.98 6 7.98C5.6925 7.98 5.4375 8.235 5.4375 8.5425C5.4375 9.4125 6.105 10.11 6.9375 10.1475V10.1925C6.9375 10.5 7.1925 10.755 7.5 10.755C7.8075 10.755 8.0625 10.5 8.0625 10.1925V10.155H8.13C8.9175 10.155 9.5625 9.4875 9.5625 8.6775C9.5625 7.9725 9.2475 7.515 8.595 7.2825ZM12.5624 16.439C14.5574 16.1915 16.1924 14.5565 16.4399 12.5615C16.5899 11.354 16.2599 10.229 15.6224 9.34397C15.2549 8.84897 14.4749 8.96897 14.2949 9.56147C13.6049 11.819 11.8274 13.604 9.5699 14.2865C8.9699 14.4665 8.8499 15.2465 9.3524 15.614C10.2299 16.259 11.3549 16.589 12.5624 16.439Z"
            fill="#FF9E48"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
